import { render, staticRenderFns } from "./CaseNumberChart.vue?vue&type=template&id=bb6fa9b0&scoped=true&"
import script from "./CaseNumberChart.vue?vue&type=script&lang=ts&"
export * from "./CaseNumberChart.vue?vue&type=script&lang=ts&"
import style0 from "./CaseNumberChart.vue?vue&type=style&index=0&id=bb6fa9b0&lang=stylus&scoped=true&"
import style1 from "./CaseNumberChart.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6fa9b0",
  null
  
)

export default component.exports